import rideTypeService from '@/http/services/ridetype'
import store from '../../../store'
export default {
  getRideTypes ({ commit }) {
    return rideTypeService.getRideTypes(store.state.apiUrl).then((response) => {
      commit('setRideTypes', response.data)
    })
  },
  addRideTypeCapacity ({ commit }, data) {
    return rideTypeService.addRideTypeCapacity(store.state.apiUrl, data).then((response) => {
    })
  },
  addRideTypeCapacityRows ({ commit }, data) {
    console.log('data rows', data)
    return rideTypeService.addRideTypeCapacityRows(store.state.apiUrl, data).then((response) => {
    })
  },
  deleteRideTypeCapacity ({ commit }, id) {
    return rideTypeService.deleteRideTypeCapacity(store.state.apiUrl, id).then((response) => {
    })
  }
}
